// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProBadge":"bcw_a bhc_rh bhc_ri bhc_vf bhc_ec bhc_vc bhc_gs bhc_kf"};